import React from "react";
import { Space } from "antd";
import { AxPopConfirm, AxDivider, AxButton } from "@dynata/axiom3";

class PopConfirm extends React.Component {
  render() {
    return (
      <div className="section" id="popconfirm">
        <h3>PopConfirm</h3>
        <p>A simple and compact confirmation dialog of an action.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxPopConfirm
  title="Are you sure to delete this task?"
  okText="Yes"
  cancelText="No"
>
  <AxButton type="link">Click here</AxButton>
</AxPopConfirm>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/popconfirm/#API"
                >
                  https://ant.design/components/popconfirm/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Param</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default value</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>title</td>
                  <td>string</td>
                  <td>The title of the confirmation box.</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>okText</td>
                  <td>string</td>
                  <td>Ok button text</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>cancelText</td>
                  <td>string</td>
                  <td>Cancel button text</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>cancelButtonProps</td>
                  <td>The cancel button props</td>
                  <td>
                    <a href="/components/button/#API">ButtonProps</a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>cancelText</td>
                  <td>The text of the Cancel button</td>
                  <td>string</td>
                  <td>
                    <code>Cancel</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>Whether show popconfirm when click its childrenNode</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>icon</td>
                  <td>Customize icon of confirmation</td>
                  <td>ReactNode</td>
                  <td>&lt;ExclamationCircle /&gt;</td>
                  <td></td>
                </tr>
                <tr>
                  <td>okButtonProps</td>
                  <td>The ok button props</td>
                  <td>
                    <a href="/components/button/#API">ButtonProps</a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>okText</td>
                  <td>The text of the Confirm button</td>
                  <td>string</td>
                  <td>
                    <code>OK</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>okType</td>
                  <td>
                    Button <code>type</code> of the Confirm button
                  </td>
                  <td>string</td>
                  <td>
                    <code>primary</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>showCancel</td>
                  <td>Show cancel button</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.18.0</td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>The title of the confirmation box</td>
                  <td>ReactNode | () =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onCancel</td>
                  <td>A callback of cancel</td>
                  <td>function(e)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onConfirm</td>
                  <td>A callback of confirmation</td>
                  <td>function(e)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/popconfirm/#API"
                      >
                        {`<Popconfirm />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxPopConfirm
  title="Are you sure to delete this task?"
  okText="Yes"
  cancelText="No"
>
  <a href="#">Normal</a>
</AxPopConfirm>
            `}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Example
        </AxDivider>

        <Space direction="vertical" size={40}>
          <AxPopConfirm
            title="Are you sure to delete this task?"
            okText="Yes"
            cancelText="No"
          >
            <AxButton type="link">Click here</AxButton>
          </AxPopConfirm>
        </Space>
      </div>
    );
  }
}
export default PopConfirm;
